import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import './style.css';
import CarEditForm from "./CarEditForm";

export default function CarEditPage(props) {
    let navigate = useNavigate();
    return (
        <>
            <div className="page">
                <header className="t">
                    <div className="t-title">הוספת / עריכת רכב</div>
                    <div className="t-actions">
                        <button className="bg" onClick={() => navigate("/admin", { replace: true })}>← חזרה</button>
                    </div>
                </header>
                <CarEditForm onCancel={() => navigate("/admin", { replace: true })} data={props.car} />
            </div>
        </>
    );
}